import { Injectable } from '@angular/core';
import { SharedService } from './shared.service';
import { HttpClient } from '@angular/common/http';
import { User } from '../home/login/login.component';
import { Router } from '@angular/router';

@Injectable()
export class AuthenticationService extends SharedService {
	public token: string;

	constructor(private http: HttpClient, private _router: Router) {
		super(http);
		// set token if saved in local storage
		const currentUser = JSON.parse(localStorage.getItem('currentUser'));
		this.token = currentUser ? currentUser.token : null;
	}

	login(user: User): any {
		return this._http.post(
			`${this.api}/users/login`, user,
		);
	}

	async saveToken(user: any, token: string) {
		this.token = token;
		localStorage.setItem(
			'currentUser',
			JSON.stringify({
				username: user.Username,
				token: token,
				role: user.Role,
				email: user.Email }),
		);
	}

	logout(): void {
		// clear token remove user from local storage to log user out
		this.token = null;
		localStorage.setItem('currentUser', null);
	}
}
